/**
 * Product page mobile conversion helpers.
 * - Sticky Buy It Now triggers Shopify dynamic checkout
 * - Marks payment button for styling
 */
(function () {
  if (document.documentElement.dataset.productMobileInit) return;
  document.documentElement.dataset.productMobileInit = 'true';

  const PAYMENT_BTN_SELECTOR =
    '.accelerated-checkout-block .shopify-payment-button__button, .accelerated-checkout-block button[type="button"]';

  function triggerBuyItNow() {
    const paymentBtn = document.querySelector(PAYMENT_BTN_SELECTOR);
    if (paymentBtn && !paymentBtn.disabled) {
      paymentBtn.click();
      return true;
    }
    const addBtn = document.querySelector(
      'product-form-component .add-to-cart-button[type="submit"], product-form-component button[name="add"]'
    );
    if (addBtn && !addBtn.disabled) {
      addBtn.click();
      return true;
    }
    return false;
  }

  function initStickyBuyNow() {
    document.querySelectorAll('[data-sticky-buy-now]:not([data-sticky-bound])').forEach((btn) => {
      btn.dataset.stickyBound = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        triggerBuyItNow();
      });
    });
  }

  function markPaymentButtons() {
    document.querySelectorAll('.accelerated-checkout-block').forEach((block) => {
      block.setAttribute('data-buy-now-primary', 'true');
    });
  }

  function observePaymentButton() {
    const form = document.querySelector('product-form-component');
    if (!form) return;

    const observer = new MutationObserver(() => {
      markPaymentButtons();
    });

    observer.observe(form, { childList: true, subtree: true });
    markPaymentButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initStickyBuyNow();
      observePaymentButton();
    });
  } else {
    initStickyBuyNow();
    observePaymentButton();
  }

  document.addEventListener('shopify:section:load', () => {
    initStickyBuyNow();
    markPaymentButtons();
  });
})();
